import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 36BC0D33-4834-41EA-8EA2-90285635005A
 * name email-open-multiple
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-open-multiple.svg
 * tags
 */
export const EmailOpenMultipleIcon = createSvgIcon(<><path d="M6,8L14,13L22,8V8L14,3L6,8V8M24,8V18A2,2 0 0,1 22,20H6A2,2 0 0,1 4,18V8C4,7.27 4.39,6.64 4.97,6.29L14,0.64L23.03,6.29C23.61,6.64 24,7.27 24,8M2,8V22H20V24H2A2,2 0 0,1 0,22V8H2Z" /></>, 'EmailOpenMultipleIcon');
export default EmailOpenMultipleIcon